module.exports = function($scope, projectSummary) {
  $scope.projectSummary = projectSummary;

  $scope.submit = function() {
    $scope.closeThisDialog({ action: "submit", projectSummary: $scope.projectSummary });
  };
  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  };
}
